module.exports = __webpack_public_path__ + "img/transfer4.f3667f65.jpg";